import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import qs from 'qs';
import axios from 'axios';
import {StoreContext} from "../../stores/contexts";
import { Link } from "react-router-dom";

class Button extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      show_inside:false,
      add_class:'',
    };
    this._docHandleClick=()=>{
      console.log('_docHandleClick');
      this.setState({ show_inside:false });
    };
  }
  renderMdiIcon() {
    if(!this.props.mdi) {
      return null;
    }
    return (
      <i className={`${this.props.danger?'const1':''}  mdi mdi-${this.props.mdi}`}></i>
    )
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.state.show_inside) {
      if(!this._onClickBinded) {
        this._onClickBinded = true;
        console.log('bind onclick');
        document.addEventListener("click", this._docHandleClick)
      }
    } else {
      if(this._onClickBinded) {
        this._onClickBinded = false;
        console.log('UNbind onclick');
        document.removeEventListener("click", this._docHandleClick)
      }
    }
  }
  dotNotate(obj,target={},prefix="") {
    if(typeof obj === "object" && obj!==null) {
      Object.keys(obj).forEach((key) => {
        if (typeof (obj[key]) === "object") {
          this.dotNotate(obj[key], target, prefix + key + ".");
        } else {
          return target[prefix + key] = obj[key];
        }
      });
    }

    return target;
  }
  renderExpand() {
    if(this.props.inside) {
      return (
        <i className={`mdi mdi-chevron-down`}></i>
      )
    }
  }
  setPlaceholders(url) {
    if(url.indexOf('{{')>-1) {
      const ob={
        order:toJS(this.context.memoryStore.memory.order),
        page:toJS(this.context.memoryStore.memory.page),
        filter:this.context.searchStore.getFilter(),
        row:this.props.row
      }
      const dotted=this.dotNotate(ob);
      const matches=url.match(/{{[0-9\_a-z\.]+}}/gi);
      for(let i in matches) {
        const index=matches[i].replace('{{','').replace('}}','');
        const replacer=dotted[index] || "";
        url=url.replace(matches[i],replacer);
      }

    }
    return url;
  }
  renderInside() {
    if(this.props.inside && this.state.show_inside) {
      return (
        <div className="pa bg-w1 vpadd10 shadow z4 wsnw tal" style={{top:'100%', right:0}}>
          {this.props.inside.map((item,index)=>{
            if(typeof item === 'string') {
              return (
                <div key={index} className="ptop10 mbottom10 solid1-bottom bo-w3"></div>
              )
            } else {
              if(this.canRender(item.conditions)) {
                if(item.set_url) {
                  let url='';
                  if(typeof window[item.set_url] == 'function') {
                    url=window[item.set_url](this.context.searchStore.par);
                  } else {
                    url=item.set_url;
                  }
                  const addProps={};
                  if(item.open_in_iframe) {
                    addProps.onClick=(e)=>{ e.preventDefault(); e.stopPropagation(); this.handleClick(item); };
                  } else {
                    addProps.onClick=(e)=>{ e.stopPropagation(); };
                  }
                  if(this.context.configStore.useRouter) {
                    return (
                      <Link {...addProps} to={this.setPlaceholders(url)} key={index} className={`stopPropagation db clear tdni b1 hpadd10 vpadd5 fs13 pointer ${this.props.add_class} ${item.danger?'const1 w1-hover bg-const1-hover':'bg-pc1-hover w1-hover'}`}>
                        {item.title}
                      </Link>
                    )
                  }
                  return (
                    <a {...addProps} href={this.setPlaceholders(url)} key={index} className={`db clear tdni b1 hpadd10 vpadd5 fs13 pointer ${this.props.add_class} ${item.danger?'const1 w1-hover bg-const1-hover':'bg-pc1-hover w1-hover'}`}>
                      {item.title}
                    </a>
                  )
                } else {
                  return (
                    <div key={index} onClick={(e)=>{ e.stopPropagation(); this.handleClick(item); }} className={`hpadd10 vpadd5 fs13 pointer ${this.props.add_class} ${item.danger?'const1 w1-hover bg-const1-hover':'bg-pc1-hover w1-hover'}`}>
                      {item.title}
                    </div>
                  )
                }
              } else {
                return null;
              }
            }
          })}
        </div>
      )
    }
  }
  isNumeric(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
  }
  canRender(cond) {
    if(cond && cond.length>0) {
      let allOk=true;
      cond.forEach((item)=>{
        if(typeof item === "string") {
          if(item === "with_selected") {
            if(this.context.selectStore.selectedCount===0) {
              allOk=false;
            }
          }
        }
        if(typeof item === "object") {
          if(item.row) {
            for(let inRow in item.row) {
              if(item.row[inRow] === ':not_blank:') {
                if(this.isNumeric(this.props.row[inRow])) {
                  if(parseFloat(this.props.row[inRow]) == 0 ) {
                    allOk=false;
                  }
                } else {
                  if (!this.props.row[inRow]) {
                    allOk=false;
                  }
                }
              } else {
                if(item.row[inRow] === ':blank:') {
                  if(this.isNumeric(this.props.row[inRow])) {
                    if(parseFloat(this.props.row[inRow]) != 0 ) {
                      allOk=false;
                    }
                  } else {
                    if (this.props.row[inRow]) {
                      allOk=false;
                    }
                  }
                } else {
                  if (this.props.row[inRow] != item.row[inRow]) {
                    allOk = false;
                  }
                }
              }
            }
          }
          if(item.func) {
            for(let inFunc in item.func) {
              if(typeof window[item.func[inFunc]] === 'function') {
                if(window[item.func[inFunc]](this.props.row,this.context.memoryStore.par)) {
                  allOk=true;
                }
              }

            }
          }
          if(item.memory) {
            let innerOk=true;
            for(let inMem in item.memory) {
              if(typeof item.memory[inMem] === "object") {
                for (let inSMem in item.memory[inMem]) {
                  if(this.context.memoryStore.memory[inMem]) {
                    if(inMem === "filter") {
                      console.log('filter check enter');
                      let inFltCheck=false;
                      for(let inFlt in this.context.searchStore.blocks) {
                         const arr=this.context.searchStore.blocks[inFlt];
                        console.log('filter cur arr', toJS(arr));
                        if(arr.code == inSMem && arr.compare === '=') {
                          if(item.memory[inMem][inSMem] === ':exists:' && arr.value) {
                            inFltCheck=true;
                          } else {
                            if (arr.value == item.memory[inMem][inSMem]) {
                              inFltCheck=true;
                            }
                          }

                        }
                      }
                      if(!inFltCheck) {
                        innerOk = false;
                      }
                    } else {
                      console.log('cond ex test', item.memory[inMem][inSMem], toJS(this.context.memoryStore.memory[inMem]));
                      if (item.memory[inMem][inSMem] !== ':exists:') {
                        if (this.context.memoryStore.memory[inMem][inSMem] != item.memory[inMem][inSMem]) {
                          innerOk = false;
                        }
                      } else {
                        console.log('exists!', item.memory[inMem][inSMem]);
                        if (!this.context.memoryStore.memory[inMem][inSMem]) {
                          innerOk = false;
                        }
                      }
                    }
                  } else {
                    console.log('cond NOT',inMem);
                    innerOk=false;
                  }
                }

              } else {
                if(this.context.memoryStore.memory[inMem] != item.memory[inMem]) {
                  innerOk=false;
                }
              }
            }
            if(!innerOk) {
              allOk=false;
            }
          }
        }
      });
      return allOk;
    }
    return true;
  }
  onIframeAction(j) {
    if(j.answer.button=="apply") {
   		return false;
   	}
   	if(j.answer.button=="cancel" || j.answer.button=="submit" || j.answer.button=="delete") {

   		this.context.memoryStore.memory.iframe=null;
      this.context.memoryStore.buildMemory();
      // this.context.dataStore.refreshData();

   		// if(typeof globalIframeCloseOnSuccessAddon != "undefined") {
   		// 	globalIframeCloseOnSuccessAddon(j);
   		// }
   		return true;
   	}
  }
  replacePlaceHolders(str,ob) {

  }
  getIdField() {
    return this.context.configStore.config.data.id_field;
  }
  handleClick(props) {
    console.log('handleClick',props);
    if(props.preset) {
      let was=false;
      switch(props.preset) {
        case "sort":
          was=true;
          if(this.context.dataStore.sort_mode) {
            this.setState({ add_class:'' });
          } else {
            this.setState({ add_class:'active' });
          }

          this.context.dataStore.sort_mode=!this.context.dataStore.sort_mode;
          break;
        case "delete":
          was=true;
          if(this.props.row) {
            if (window.confirm("Вы уверены?")) {
              axios.post(this.context.configStore.config.data.delete_route, {items: [this.props.row[this.getIdField()]] }).then(() => {
                this.context.dataStore.refreshData();
              });
            }
          } else {
            if (window.confirm("Вы уверены?")) {
              axios.post(this.context.configStore.config.data.delete_route, {items: this.context.selectStore.getIds()}).then(() => {
                this.context.dataStore.refreshData();
                this.context.selectStore.unselectAll();
              });
            }
          }
          break;
        case "published":
          was=true;
          axios.post(this.context.configStore.config.data.edit_route, {items: [{ id:this.props.row[this.getIdField()], main:{published:this.props.row.published==='1'?'0':'1' } }] }).then(() => {
            this.context.dataStore.refreshData();
          });
          break;
        case "edit":
          /*this.handleClick({
            open_in_iframe: true,
            set_url: this.props.row.detail_url,
          })*/
          break;
      }
      if(was) {
        return true;
      }
    }
    if(props.inside) {
      this.setState({ show_inside:!this.state.show_inside });
    } else {
      var tmpFnc=()=>{
        if (props.open_in_iframe || props.preset === 'edit') {
          const ext = this.setPlaceholders(props.set_url).split('?');
          const queryOb = qs.parse(ext[1])
          queryOb.mode = 'iframe';
          queryOb.sideblock = 'off';

          if(props.iframe_action) {
            queryOb.onAction = 'onIframeAction';
            window.onIframeAction = (ob) => {
              return window[props.iframe_action](ob, this.context.configStore.par);
            };
            // queryOb.onAction = props.iframe_action;
          } else {
            window.onIframeAction = (ob) => {
              return this.onIframeAction(ob);
            };
            queryOb.onAction = 'onIframeAction';
          }
          const query = qs.stringify(queryOb);
          console.log('in iframe', query, queryOb, ext[0]);
          this.context.memoryStore.memory.iframe = ext[0] + '?' + query;
          this.context.memoryStore.buildMemory();
        }
        if (props.on_click) {
          console.log("ONCLICK", props.on_click,this.context.configStore.actionsHandler);
          if(this.context.configStore.actionsHandler) {
            if(this.props.row) {
              this.context.configStore.actionsHandler(props.on_click, this.props.row, this.context.searchStore.par);
            } else {
              this.context.configStore.actionsHandler(props.on_click, this.context.searchStore.par);
            }
          } else {
            if (typeof window[props.on_click] === "function") {
              if (this.props.row) {
                window[props.on_click](this.props.row, this.context.searchStore.par);
              } else {
                window[props.on_click](this.context.searchStore.par);
              }
            }
          }
        }
      }

      if(props.danger) {
        if(window.confirm("Вы уверены?")) {
          tmpFnc();
        }
      } else {
        tmpFnc();
      }

    }
  }
  getConditionalClass(props) {
    if(props.preset === 'published') {
      if(props.row.published !== '1') {
        return 'transp50';
      }
    }
    return '';
  }
  render() {
    if(this.canRender(this.props.conditions)) {

      const item=this.props;
      if(item.set_url || item.preset === 'edit') {
        let url='';
        if(typeof window[item.set_url] == 'function') {
          url=window[item.set_url](this.context.searchStore.par);
        } else {
          url=item.preset === 'edit'?this.props.row.detail_url:item.set_url;
        }
        const addProps={};
        if(this.props.open_in_iframe || item.preset === 'edit') {
          addProps.onClick=(e)=>{ e.preventDefault(); e.stopPropagation(); this.handleClick(item); }
        } else {
          addProps.onClick=(e)=>{ e.stopPropagation(); };
        }
        if(!this.props.type && this.props.children) {
          if(this.context.configStore.useRouter) {
            return (
              <Link {...addProps} to={this.setPlaceholders(url)} className={` ${this.props.add_btn_class || ''} `}>
                {this.props.children}
              </Link>
            )
          } else {
            return (
              <a {...addProps} href={this.setPlaceholders(url)} className={` ${this.props.add_btn_class || ''} `}>
                {this.props.children}
              </a>
            )
          }
        } else {
          if(this.context.configStore.useRouter) {
            return (
              <span onClick={(e)=>{ e.stopPropagation(); }} className={`stopPropagation dib vam pr ${this.props.addClass} ${this.props.add_class} ${this.getConditionalClass(this.props)}`}>
                <Link {...addProps} to={this.setPlaceholders(url)} className={`stopPropagation ${this.props.type} withIcon ${this.props.add_btn_class || ''}  ${!this.props.title && this.props.mdi?'iconOnly':''}`}>
                  <span>{this.renderMdiIcon()}{this.props.title}</span>
                </Link>
              </span>
            )
          }
          return (
            <span className={`dib vam pr ${this.props.addClass} ${this.props.add_class} ${this.getConditionalClass(this.props)}`}>
              <a {...addProps} href={this.setPlaceholders(url)} className={`${this.props.type} withIcon ${this.props.add_btn_class || ''}  ${!this.props.title && this.props.mdi?'iconOnly':''}`}>
                <span>{this.renderMdiIcon()}{this.props.title}</span>
              </a>
            </span>
          )
        }
      } else {
        if(!this.props.type && this.props.children) {
          const addProps={};
          if(this.props.on_click) {
            addProps.onClick=(e)=>{
              e.preventDefault(); e.stopPropagation(); this.handleClick(this.props);
            };
          } else  {
            addProps.onClick=(e)=>{ e.stopPropagation(); };
          }
          return (
            <span {...addProps} className={`stopPropagation pointer bold ${this.props.add_btn_class || ''}`}>
              {this.props.children}
            </span>
          )
        } else {
          return (
            <span data-id={this.props.row?this.props.row[this.getIdField()]:null} className={`dib vam pr ${this.props.addClass || ''} ${this.props.add_class || ''} ${this.getConditionalClass(this.props)}`}>
              <span onClick={(e)=>{ e.stopPropagation();  this.handleClick(this.props); }} className={`stopPropagation ${this.props.type} withIcon ${this.state.add_class} ${this.props.add_btn_class || ''} ${!this.props.title && this.props.mdi?'iconOnly':''}`}>
                <span>{this.renderMdiIcon()}{this.props.title}{this.renderExpand()}</span>
              </span>
              {this.renderInside()}
            </span>
          )
        }
      }

      return (
        <span data-id={this.props.row?this.props.row[this.getIdField()]:null} className={`dib vam pr ${this.props.addClass} ${this.props.add_class} ${this.getConditionalClass(this.props)}`}>
          <span onClick={(e)=>{ e.stopPropagation(); this.handleClick(this.props); }} className={`stopPropagation ${this.props.type} withIcon ${this.state.add_class} ${!this.props.title && this.props.mdi?'iconOnly':''}`}>
            <span>{this.renderMdiIcon()}{this.props.title}{this.renderExpand()}</span>
          </span>
          {this.renderInside()}
        </span>
      )
    }
    return null;
  }
}

// export default inject("selectStore","memoryStore","searchStore","dataStore","configStore")(observer(Button));
export default observer(Button);